<template>
  <div id="top-nav">
    <b-navbar
      toggleable="sm"
      fixed="top"
    >
      <div class="container">
        <b-navbar-toggle target="nav_collapse" />
        <b-collapse
          is-nav
          id="nav_collapse"
        >
          <b-navbar-nav>
            <b-nav-item
              :to="{ path: '/' }"
              exact
            >
              <font-awesome-icon
                fixed-width
                icon="users"
              />
              Job Listings
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'my-applications' }"
              exact
              v-if="isSignedIn"
            >
              <font-awesome-icon
                fixed-width
                icon="file-alt"
              />
              Your Applications
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav
            class="ml-auto"
            v-if="isSignedIn"
          >
            <b-nav-item-dropdown
              :html="user.email"
              right
            >
              <b-dropdown-item :to="{ name: 'user-basic-profile'} ">
                <font-awesome-icon
                  fixed-width
                  icon="user-circle"
                />
                Your contact details
              </b-dropdown-item>
              <b-dropdown-item :to="{ name: 'job-application-profile/about-you'} ">
                <font-awesome-icon
                  fixed-width
                  icon="pencil-alt"
                />
                {{ $tc('myProfile.heading') }}
              </b-dropdown-item>
              <b-dropdown-item @click="signOut">
                <font-awesome-icon
                  fixed-width
                  icon="sign-out-alt"
                />
                Sign Out
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav
            class="ml-auto"
            v-if="!isSignedIn"
          >
            <b-nav-item
              :to="{ path: '/sign-in' }"
              exact
            >
              <font-awesome-icon
                fixed-width
                icon="sign-in-alt"
              />
              Sign-in
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      isSignedIn: 'auth/isSignedIn',
      user: 'auth/user',
    }),
    canAccessApp() {
      return this.$ability.can('access', 'app.recruitment');
    },
  },
  created() {
  },
  methods: {
    async signOut() {
      await this.$store.dispatch('auth/logoutUser');
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>
